import React, { useMemo } from 'react'
import styles from './ManageUserPage.module.scss'
import {
  managerCanAssignLearningItemsToGroupMember,
  userCanAssignLearningItems,
} from '../../state/calculations/permissions/userCan'
import Button from '../../components/basics/Button/Button'
import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { useSession } from '../../state/session'
import useRoutes from '../../state/useRoutes'
import { useUser } from '../../state/entities'
import useUserLearningItems from '../../state/queries/useUserLearningItems'
import { unfinishedLearningPaths } from '../../state/calculations/unfinishedLearningItems'
import {
  getLearningItemUuids,
  hasAssignmentsFromOtherGroupsThanFromLoggedManager,
  isAssignedByUser,
  UnfinishedLearningItem,
} from './ManageUserPageLearningAssignments'
import useUserBookedLearningItems from '../../state/queries/useUserBookedLearningItems'

export default React.memo(function ManageUserPageLearningPathAssignments({ uuid }: { uuid: string }) {
  const { t } = useTranslation()
  const routes = useRoutes()
  const { user: currentUser } = useSession()
  const { user } = useUser(uuid)

  const { userLearningItems } = useUserLearningItems(uuid)

  const unfinishedPaths = useMemo(() => unfinishedLearningPaths(userLearningItems), [userLearningItems, uuid])

  const unfinishedLearningItemUuids = getLearningItemUuids(unfinishedPaths)

  const { userBookedLearningItems } = useUserBookedLearningItems(uuid, unfinishedLearningItemUuids, currentUser?.uuid)

  return (
    <section className={styles.ManageUserPageLearningPathAssignments}>
      <header>
        <h1>{t('learning paths assignments')}</h1>
        {(userCanAssignLearningItems(currentUser) ||
          managerCanAssignLearningItemsToGroupMember(currentUser?.managedGroups || [], user.groups || [])) && (
          <Button
            small
            component={Link}
            to={routes.addLearningItemsToUser.url({ uuid, pathsOrCourses: '1' })}
            preventScrollReset
          >
            {t('manage learning.cta assign learning item')}
          </Button>
        )}
      </header>

      <main>
        {unfinishedPaths.map(({ learningItem, assignment }) => (
          <UnfinishedLearningItem
            key={learningItem.uuid}
            userUuid={uuid}
            learningItem={learningItem}
            assignment={assignment as any}
            isBooked={false}
            hasAssignmentsFromOtherGroupsThanFromLoggedManager={hasAssignmentsFromOtherGroupsThanFromLoggedManager(
              userBookedLearningItems,
              learningItem.uuid
            )}
            isAssignedByUser={isAssignedByUser(learningItem)}
          />
        ))}

        {!unfinishedPaths.length && <span className={styles.empty}>{t('no learning paths assignments found')}</span>}
      </main>
    </section>
  )
})
